import { Model } from '@vuex-orm/core';
import { Scope } from './Scope';
import { User } from '../User';

export const STATUSSES = {
  NO_PROFILE: 0,
  ACTIVATING: 10,
  ACTIVE: 20,
  CANCELLING: 30,
  CANCELLED: 40
};

/**
 * ORM Model
 * @see {@link https://vuex-orm.github.io/vuex-orm/guide/components/models.html}
 */
export class ScopeProfile extends Model {
  static entity = 'scopeProfiles'

  static primaryKey = ['user_id', 'scope_key']

  static fields () {
    return {
      scope_key: this.attr(null),
      scope: this.belongsTo(Scope, 'scope_key'),
      user_id: this.attr(null),
      user: this.belongsTo(User, 'user_id'),
      status: this.attr(null)
    };
  }

  setStatus (status) {
    this.status = status;
    this.$save();
  }

  get isActive () {
    return this.status === 20;
  }

  get isPending () {
    return this.status === 10;
  }

  get noProfile () {
    return this.status === 0;
  }
}
